import React, { ChangeEvent } from "react";
import { CONSTANTS } from "../../constants/Constants";
import Input from "../Inputs";
import Modal from "../Modal";
import cloudIcon from "../../assets/icons/cloud_icon.svg";
import Textarea from "../Textarea";
import Select from "../Select";
import crossIcon from '../../assets/icons/cross_icon.svg'

interface VideoProps {
  setIsModalOpen: any;
  payload: any;
  mediaChangeHandler: (e: ChangeEvent) => void;
  saveMediaHandler: () => void;
  isLinkDisabled?: boolean
  isMediaDisabled?: boolean
  removeMediaFileHandler: ()=> void
}

const VideoModal: React.FC<VideoProps> = ({
  setIsModalOpen,
  mediaChangeHandler,
  payload,
  saveMediaHandler,
  isLinkDisabled,
  isMediaDisabled,
  removeMediaFileHandler
}) => {
  
  return (
    <div>
      <Modal
        modal_title={CONSTANTS.MODIFY_MEDIA_TXT}
        modal_handler={setIsModalOpen}
        save_handler={saveMediaHandler}
      >
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-2">
          <div className="flex flex-col justify-center items-center col-span-7 bg-gray-200 rounded p-4">
            <img src={cloudIcon} alt="Upload Icon" className="w-16 h-16" />
            <div className="text-center space-y-2 mt-3 w-full">
              <label
                htmlFor="file-upload"
                className={`text-xs bg-white text-black px-3 py-2 rounded w-9/12 block mx-auto ${
                  isMediaDisabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
                }`}
              >
                {CONSTANTS.CHOOSE_UPLOAD_FILE_TXT}
              </label>
              {payload[
                CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.NAME
              ] && payload[CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.MEDIA_FILE] && (
                <>
                <small className="w-full justify-center m-auto mt- text-[11px] flex items-center gap-1">
                  <span className="max-w-60 mr-1 h-[15px] overflow-hidden text-ellipsis whitespace-nowrap inline-block">{`${
                    payload[
                      CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.NAME
                    ]
                  } is added`}</span> 

                  <button onClick={removeMediaFileHandler}>
                    <img 
                      src={crossIcon} 
                      alt="cross_icon"
                      className="w-4 bg-gray-50 p-[3px] rounded-full" 
                    />
                  </button>
                </small>
                </>
              )}

              <input
                name={
                  CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.MEDIA_FILE
                }
                disabled={isMediaDisabled}
                id="file-upload"
                type="file"
                onChange={mediaChangeHandler}
                className="hidden"
              />
            </div>
            <p className="text-xs mt-5">{CONSTANTS.PROVIDE_LINK_TXT}</p>
            <Input
              is_disable={isLinkDisabled}
              input_name={
                CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.MEDIA_URL
              }
              value={
                payload[
                  CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.MEDIA_URL
                ]
              }
              change_handler={mediaChangeHandler}
              placeholder="Paste link here"
              other_classes={`w-[87%] text-xs h-7 px-2 mt-3 ${
                isLinkDisabled ? "cursor-not-allowed opacity-50 bg-gray-50" : ""
            }`}
            />
          </div>

          <div className="col-span-5">
            <div className="flex flex-col mb-4">
              <label className="mb-1 text-sm">
                {CONSTANTS.TITLE_TXT}
                <span className="text-error mr-1">*</span>
              </label>
              <Input
                input_name={
                  CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.NAME
                }
                value={
                  payload[
                    CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.NAME
                  ]
                }
                change_handler={mediaChangeHandler}
                placeholder="Add title"
                other_classes="text-sm h-9"
              />
            </div>

            <div className="flex flex-col mb-4">
              <label className="mb-1 text-sm">
                {CONSTANTS.DESCRIPTION_TXT}
              </label>
              <Textarea
                name={
                  CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.DESCRIPTION
                }
                placeholder={CONSTANTS.DESCRIPTION_TXT}
                change_handler={mediaChangeHandler}
                value={
                  payload[
                    CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
                      .DESCRIPTION
                  ]
                }
                maxLength={300}
                other_classes="text-sm h-20 border border-[#E6E6E6] rounded focus:outline-none"
              />
              <small className="flex justify-end text-gray-500 mt-1">
                {CONSTANTS.MAXIMUM_LENGTH_DESCRIPTION_TXT} {300}
              </small>
            </div>

            <div className="flex flex-col mb-4">
              <label className="mb-1 text-sm">
                {CONSTANTS.SHOW_ON_PROFILE_TXT}
              </label>
              <Select
                name={CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.STATUS}
                other_classes="text-sm h-9 rounded-md"
                options={[
                  {
                    id: CONSTANTS.ENABLED_TXT.toLocaleUpperCase(),
                    name: CONSTANTS.YES_TXT,
                  },
                  {
                    id: CONSTANTS.DISABLED_TXT.toLocaleUpperCase(),
                    name: CONSTANTS.NO_TXT,
                  },
                ]}
                handle_change={mediaChangeHandler}
                value={
                  payload[
                    CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.STATUS
                  ]
                }
              />
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default VideoModal;
